import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import { SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import { LOGIN_PAGE, REGISTRATION_SUCCESS_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { CREATE_NEW_USER_URL } from "../../api/apiRoutes";
import { WebUser } from "../../models/WebUser";
import useFacility from "../../../utils/hooks/useFacility";
import { FormElementModel } from "../../models/FormElementModel";
import { userRegisterForm } from "./inputsForm/InputRegisterFormModels";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { userPayCheckboxForm } from "../FinalizePage/inputsForm/CheckboxPayFormModel";
import { useTranslation } from "react-i18next";
import { clearErrors } from "../../store/alerts/alertsActions";
import CheckBoxNewsletter from "../FinalizePage/inputsForm/CheckBoxNewsletter";

type Inputs = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  repeatPassword: string;
  phone: string;
  acceptStatute: boolean;
};

const Registration: React.FC = () => {
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<Inputs>({
    defaultValues: {
      acceptStatute: false,
    },
  });

  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const handleRegistration: SubmitHandler<Inputs> = async (data) => {
    setEmail(data.email)
    const webUser: WebUser = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      phone: data.phone,
      allowMailing: false,
    } as WebUser;
    const { isError } = await post(CREATE_NEW_USER_URL(facilityIds), webUser);
    if (!isError) {
      navigate(REGISTRATION_SUCCESS_PAGE);
    }
 

  };
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const [email, setEmail] = useState<string>();
  
  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="registration-page flex-center-center">
      <div className="padding-big box shadow border">
        <form onSubmit={handleSubmit(handleRegistration)}>
          <h1 className="italic">{t("zarejestruj_sie")}</h1>
          <span className="flex-center-center">
            {t("masz_juz_konto")}
            <button className="button medium padding-zero button-text-main" onClick={() => navigate(LOGIN_PAGE)}>
              {t("zaloguj_sie")}
            </button>
          </span>

          <div className="flex-start-center flex-wrap">
            {userRegisterForm(watch, register).map((item: FormElementModel, index: number) => (
              <FormInput key={index} {...item} errors={errors} />
            ))}
          </div>

          <div className="checkbox-box">
            {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
              <React.Fragment key={index}>{item}</React.Fragment>
            ))}
          </div>

          {facilityIds === '1228' && <CheckBoxNewsletter email={email}/>}     


          {/* <Controller
            name={"acceptStatute"}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (


              <CheckBoxInput
                name={"acceptStatute"}
                field={field}
                title={
                  <span>
                    * Kontynuując, akceptujesz regulamin korzystania z serwisu eAktywni, Politykę prywatności oraz
                    warunki korzystania z plików cookie.
                  </span>
                }
                errors={errors}
              />
            )}
          />  */}

          {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

          <div>
            <input
              className="button full-button button-fill-main padding-big big"
              type={"submit"}
              value={t("zarejestruj_sie")}
            />

            {/* <span>lub</span>
            <button className={"register-button"} onClick={() => navigate(LOGIN_PAGE)}>
              Zaloguj się
            </button> */}
          </div>

          <div className="alert alert-yellow">
            <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_createNewAccount }}></article>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registration;
